import React, { useContext } from 'react';
import { withRouter } from 'react-router-dom';
import {
    Typography, withStyles, AppBar, Toolbar, IconButton,
    Hidden, Drawer, List, ListItem, ListItemText, Popover, ListItemAvatar, Avatar, Divider, Button, Link,
} from '@material-ui/core';
import Span from "@material-ui/core/Box";
import AccountCircle from '@material-ui/icons/AccountCircle';
import MenuIcon from '@material-ui/icons/Menu';
import CloseIcon from '@material-ui/icons/Close';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUserCircle } from '@fortawesome/free-solid-svg-icons';
import Logo from "../../assets/Logo_CK.png"
import { userLogout } from '../../helper/commonFunction';
import SideNavigationsMenu from '../DashboardLayout/SideNavigations/SideNavigationsMenu';
import { UserAccountContext } from '../../contextHooks';
import { NavLink } from 'react-router-dom';

const styles = (theme) => ({
    Logo: { width: 180 },
    AppbarCss: { boxShadow: 'none', background: '#fff', height: 70, borderTop: '3px solid #1b5e20', borderBottom: '1px solid #dadada' },
    ToolBarHeight: { minHeight: 52 },
    HeaderItems: { color: '#3d3d3d', fontWeight: 500 },
    HeaderEmail: { color: '#3d3d3d', fontWeight: 500, marginRight: "20px" },
    ItemContainer: { padding: 0, borderRadius: 0, background: 'transparent', margin: '0px 5px', color: '#2b2b2b', '&:hover': { background: 'transparent' } },
    HeaderIcons: { fontSize: 33, color: '#1b5e20' },
    HeaderItemText: { fontSize: 11, lineHeight: '0.60rem', color: '#000' },
    BadgeCss: { transform: 'initial', minWidth: 10, height: 10, marginRight: 4, marginTop: 10, background: '#1b5e20', padding: '0px 0px' },
    ProfileDropdown: { marginTop: 18, width: 300, outline: 'none', padding: '12px 6px' },
    MenuButton: { padding: 0 },
    drawerPaper: { marginTop: 70, background: '#1b5e20', boxShadow: 'none', width: 70, borderRight: 'none', },
    ListItemCss: { display: 'block', textAlign: 'center', paddingTop: 10, paddingBottom: 3 },
    ListContainer: { textAlign: 'center' },
    ListItemIconCss: { minWidth: 0, fontSize: 30, color: '#fff' },
    ListItemTextCss: { color: '#fff', fontSize: 11 },
    ListItemTextToolsCss: { color: '#fff', fontSize: 11, marginTop: 6 },
    AlertDropdown: { padding: '10px 10px', width: 210, top: '63px !important' },
    UserCircleIcon: { fontSize: 60, color: "#1b5e20" },
    UserDetails: { fontSize: 15, marginTop: 3, wordBreak: 'break-all' },
    UserBtns: { fontSize: 12, border: '1px solid #1b5e20', color: '#1b5e20', margin: '0px 4px', padding: '5px 7px', '&:hover': { background: 'none' } },
    UserBtnIcons: { fontSize: 21, marginRight: 2 },
    ActiveUserEmail: { fontSize: 14, padding: "0px 8px", cursor: "pointer" },
    NavbarAlign: { display: "flex", justifyItems: "center", alignItems: "center", color: "#000" },
    ManageUserBtn: { fontSize: 14, padding: "0px 6px", textTransform: "capitalize", margin: "0px 8px", "&:hover": { background: "none", boxShadow: "none" } },

})

const Navbar = (props) => {
    const { classes } = props;
    const userAccount = useContext(UserAccountContext);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [expanded, setExpanded] = React.useState(false);
    const open = Boolean(anchorEl);
    const handleMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };
    const handleExpandClick = () => {
        setExpanded(!expanded);
    };

    // notification alert
    const [anchorElAlert, setAnchorElAlert] = React.useState(null);
    const openAlert = Boolean(anchorElAlert);

    const handleCloseAlert = () => {
        setAnchorElAlert(null);
    };

    const onClickLogoutHandler = () => {
        setAnchorEl(null);
        userLogout(props);
    }
    return (
        <React.Fragment>
            <AppBar position='fixed' classes={{ root: classes.AppbarCss }}>
                <Toolbar className={classes.ToolBarHeight}>
                    <Hidden only={['sm', 'xl', 'md', 'lg']}>
                        <IconButton className={classes.MenuButton} disableRipple onClick={handleExpandClick} >
                            <Span align="center" display="grid" justifyItems='center'>
                                {(expanded) ? <CloseIcon classes={{ root: classes.HeaderIcons }} /> : <MenuIcon classes={{ root: classes.HeaderIcons }} />}
                            </Span>
                        </IconButton>
                        <Drawer
                            variant="temporary"
                            anchor="left"
                            open={expanded}
                            onClose={handleExpandClick}
                            classes={{ paperAnchorLeft: classes.drawerPaper }}
                            ModalProps={{
                                BackdropProps: { invisible: true }
                            }}
                        >
                            <SideNavigationsMenu
                                pageUri={props.location.pathname}
                            />
                        </Drawer>
                    </Hidden>
                    <Span flexGrow={1} mt={1}>
                        <img className={classes.Logo} src={Logo} alt='header-logo' />
                    </Span>

                    <div>
                        <Popover
                            open={openAlert}
                            anchorEl={anchorElAlert}
                            onClose={handleCloseAlert}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'center',
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'center',
                            }}
                            classes={{ paper: classes.AlertDropdown }}
                        >
                            <List>
                                <ListItem alignItems="flex-start">
                                    <ListItemAvatar>
                                        <Avatar />
                                    </ListItemAvatar>
                                    <ListItemText
                                        primary='mark has schedule campaign.'
                                        secondary={
                                            <div>
                                                <Typography
                                                    component="span"
                                                    variant="body2"
                                                    className={classes.inline}
                                                    color="textPrimary"
                                                >
                                                    10:46 PM Feb 23 2021
                                                </Typography>
                                            </div>
                                        }
                                    />
                                </ListItem>
                            </List>
                        </Popover>
                    </div>
                    <div>
                        <Span className={classes.NavbarAlign}>
                            {
                                (userAccount && (userAccount.usr_role_id === '2')) &&
                                <Span>
                                    <Link component={NavLink} to={`/admin/edit-user/${userAccount.usr_id}`} className={classes.ActiveUserEmail}>  {userAccount.email}</Link>
                                    <Hidden only={"xs"}>|</Hidden>
                                    <Button variant='text' className={classes.ManageUserBtn} component={NavLink} to="/admin/manage-users">Manage Users</Button>
                                </Span>
                            }
                            <IconButton className={classes.ItemContainer} disableRipple aria-haspopup="true" onClick={handleMenu}>
                                <AccountCircle classes={{ root: classes.HeaderIcons }} />
                            </IconButton>
                        </Span>

                        <Popover
                            id="menu-appbar"
                            anchorEl={anchorEl}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'center',
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'center',
                            }}
                            open={open}
                            onClose={handleClose}
                            classes={{ paper: classes.ProfileDropdown }}
                        >
                            <Span align='center'>
                                <FontAwesomeIcon icon={faUserCircle} className={classes.UserCircleIcon} />
                                <Typography variant='subtitle2' className={classes.UserDetails}>
                                    {(userAccount.first_name) && userAccount.first_name + ' '}
                                    {(userAccount.last_name) && userAccount.last_name}
                                </Typography>
                                <Typography variant='subtitle2' className={classes.UserDetails}>
                                    {(userAccount.email) && 'Email : ' + userAccount.email}
                                </Typography>
                                <Span mt={1.7}><Divider /></Span>
                                <Span mt={2}>

                                    <Button
                                        size='small'
                                        className={classes.UserBtns}
                                        onClick={onClickLogoutHandler}
                                    >
                                        <ExitToAppIcon className={classes.UserBtnIcons} />
                                        Logout
                                    </Button>
                                </Span>
                            </Span>
                        </Popover>
                    </div>
                </Toolbar>
            </AppBar>
        </React.Fragment>
    )
}

export default withStyles(styles)(withRouter(Navbar));